<template>
  <div class="all">
    <div class="header-top">
      <span class="header_h">
        <i class="iconfont iconrenyuanxinxi icon_1" />
        内部人员
      </span>
      <div
        style="
          background-color: #ebefff;
          width: 100%;
          height: 1px;
          margin-top: 10px;
        "
      />
      <el-form inline @submit.native.prevent="getPersonList(1)">
        <el-form-item
          label="账号状态:"
          class="header_b"
          style="margin-left: 20px"
        >
          <el-select
            v-model="searchQuery.isEnabled"
            size="small"
            style="width: 120px"
            clearable
            filterable
            @change="getPersonList(1)"
            class="isEnabledsty"
          >
            <el-option
              v-for="item in isqiyongoptions"
              :key="item.id"
              :value="item.id"
              :label="item.label"
            />
          </el-select>
        </el-form-item>
        <el-form-item class="header_b">
          <el-button
            size="small"
            type="danger"
            plain
            @click="pldeletePerson"
            :disabled="this.pageSelect.length == 0"
            v-if="deleBatchInfo"
          >
            批量删除
          </el-button>
          <el-button
            plain
            size="small"
            @click="daoru"
            type="primary"
            v-if="exportInfo"
          >
            导入
          </el-button>
          <el-button
            plain
            size="small"
            @click="exportExcel"
            type="primary"
            v-if="exportInfo"
            :loading="exportLoading"
          >
            导出
          </el-button>
          <el-button plain size="small" @click="invite" type="primary">
            新增成员
          </el-button>
          <el-button
            plain
            size="small"
            @click="gomorepersonInfo"
            type="primary"
          >
            更多成员
          </el-button>
        </el-form-item>
        <div style="float: right; margin-top: 7px">
          <el-form-item>
            <el-input
              v-model="searchQuery.keyword"
              placeholder="请输入姓名/手机号"
              style="width: 307px"
              size="small"
              @input="changeinput"
              clearable
            >
              <template #prefix>
                <i
                  class="el-icon-search el-input__icon"
                  @click="getPersonList(1)"
                />
              </template>
            </el-input>
          </el-form-item>
        </div>
      </el-form>
      <editPerson ref="add" @getfreshen="getfreshen1" />
    </div>
    <div class="midd">
      <el-table
        v-loading="loading"
        :data="tableData"
        element-loading-text="拼命加载中"
        class="jk-table"
        highlight-current-row
        height="100%"
        :row-style="rowStyle"
        :header-cell-style="headerStyle"
        @row-click="handleDelete"
        @row-dblclick="detailInfo"
        @select-all="selectall"
        @select="selectchange"
        ref="multipleTable"
      >
        <template slot="empty">
          <img :src="zanwu" />
          <p style="font-size: 16px; color: #000; margin-top: 36px">暂无数据</p>
        </template>
        <el-table-column type="selection" align="center" />
        <el-table-column label="姓名" prop="name" align="center" />
        <el-table-column
          label="手机号"
          prop="phone"
          min-width="120px"
          align="center"
        />
        <el-table-column
          label="性别"
          prop="$sex"
          min-width="120px"
          align="center"
        />
        <el-table-column
          label="部门"
          prop="depName"
          min-width="120px"
          align="center"
        >
          <template slot-scope="scope">
            <span :title="scope.row.depNametitle">{{ scope.row.depName }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="账号状态"
          prop="$isEnabled"
          min-width="120px"
          align="center"
        />
        <!-- <el-table-column label="人员类别" prop="isExternal" min-width="120px" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.isExternal == '1'">外部</span>
            <span v-if="scope.row.isExternal == '0'">内部</span>
          </template>
        </el-table-column> -->
        <el-table-column label="操作" align="center" min-width="120px">
          <template slot-scope="scope">
            <span
              @click="qiyong(scope.row)"
              class="btn"
              v-if="scope.row.isEnabled == 0 && enableInfo"
              >启用</span
            >
            <span
              @click="jinyong(scope.row)"
              class="btn"
              v-if="scope.row.isEnabled == 1 && enableInfo"
              >禁用</span
            >
            <span @click="detailInfo(scope.row)" class="btn" v-if="seeInfo"
              >查看</span
            >
            <span @click="editPerson(scope.row)" class="btn" v-if="editInfo"
              >修改</span
            >
            <span @click="deletePerson(scope.row)" class="btn" v-if="deleInfo"
              >删除</span
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <page
      :page="page"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="getPersonList"
      class="page-1"
    ></page>
    <el-dialog
      title="导入"
      v-dialogDrag
      custom-class="daoru-dialog"
      :visible.sync="professionDialogVisible4"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="600px"
      :before-close="handlePofessionClose4"
    >
      <span>
        <div style="height: 32px; line-height: 32px" v-if="!fileList2.length">
          <p style="float: left">请下载导入模板，按格式修改后导入</p>
          <el-button
            style="float: right"
            size="small"
            type="primary"
            @click="down"
          >
            模板下载
          </el-button>
        </div>
        <div v-if="!fileList2.length">
          <div style="text-align: center; margin-top: 15px">
            <el-upload
              drag
              action="/"
              :before-upload="dataprogress1"
              :show-file-list="false"
              :http-request="httpRequest"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将文件拖拽至此区域，或<em>点击上传</em>
              </div>
              <div class="el-upload__tip" slot="tip">
                仅支持xls、xlsx格式，文件大小不超过5M
              </div>
            </el-upload>
          </div>
        </div>
        <div v-if="fileList2.length && isfail == 2">
          <div
            style="
              text-align: center;
              border: 1px dashed #d9d9d9;
              border-radius: 6px;
              width: 360px;
              margin: 0 auto;
              padding: 50px 0px;
            "
          >
            <img :src="xlssrc" alt="" style="vertical-align: text-bottom" />
            <p>
              <span>{{ fileList2[0].name }}</span>
            </p>
          </div>
          <div style="text-align: center; margin-top: 20px">
            <el-button
              size="small"
              type="primary"
              plain
              @click="newuplode"
              :loading="disabledone2"
            >
              重新上传
            </el-button>
            <el-button
              size="small"
              type="primary"
              @click="suredaoru"
              :loading="disabledone2"
            >
              确认导入
            </el-button>
          </div>
        </div>
        <div v-if="fileList2.length && isfail == 1">
          <div style="text-align: center">
            <img :src="dangersrc" alt="" />
          </div>
          <p style="text-align: center; margin-top: 20px; font-size: 16px">
            <span style="color: #409eff">{{ successtotals }}</span
            >条导入成功， <span style="color: #e6a23c">{{ dangertotals }}</span
            >条导入失败
            <span
              @click="getList(dangerlist)"
              style="color: #409eff; cursor: pointer"
              >下载失败列表</span
            >
          </p>
          <div style="text-align: center; margin-top: 20px">
            <el-button size="small" type="primary" plain @click="newuplode">
              重新导入
            </el-button>
          </div>
        </div>
        <div v-if="fileList2.length && isfail == 0">
          <div style="text-align: center">
            <img :src="successsrc" alt="" />
          </div>
          <p style="text-align: center; margin-top: 20px; font-size: 16px">
            <span style="color: #409eff">{{ successtotals }}</span
            >条导入成功
          </p>
          <div style="text-align: center; margin-top: 20px">
            <el-button size="small" type="primary" plain @click="newuplode">
              继续导入
            </el-button>
          </div>
        </div>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import editPerson from "./editPerson";
import page from "@/CommonDP/components/paging";
import systemPersonService from "@/CommonDP/service/enterprisePerson-service";
import interiorService from "@/xgzdService/interiorPerson-service";
import { checkPermission, disablePrompt } from "@/utils/routeAuth";
import { getToken } from "@/CommonDP/utils";
import { downloadTemplate } from "@/utils";
import { mapState } from "vuex";
import axios from "axios";
export default {
  components: { editPerson, page },
  data() {
    return {
      invitationInfo: checkPermission(":personInfo:invitation"),
      moreInfo: checkPermission(":personInfo:more"),
      deleBatchInfo: checkPermission(":personInfo:deleBatch"),
      exportInfo: checkPermission(":personInfo:export"),
      seeInfo: checkPermission(":personInfo:see"),
      editInfo: checkPermission(":personInfo:edit"),
      deleInfo: checkPermission(":personInfo:dele"),
      resetPassInfo: checkPermission(":personInfo:resetPass"),
      addInfo: checkPermission(":personInfo:add"),
      enableInfo: checkPermission(":personInfo:enable"),
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      loading: false,
      tableData: [],
      searchQuery: {
        keyword: "",
        isExternal: 0,
        isEnabled: "",
      },
      page: {
        pageNum: 1,
        pageSize: 10,
        totalCount: 0,
      },
      userId: undefined,
      iswaioptions: [
        { id: "1", label: "外部" },
        { id: "0", label: "内部" },
      ],
      isqiyongoptions: [
        { id: "1", label: "启用" },
        { id: "0", label: "禁用" },
      ],
      pageSelect: [], //勾选的数据
      rows: {},
      professionDialogVisible4: false,
      xlssrc: require("@/CommonDP/assets/addpersonInfo/图表.png"),
      fileList2: [], //上传的文件      有文件 就展示文件列表页面 没文件就展示选择文件的页面
      disabledone2: false, //正在调用上传文件的接口
      dangerlist: [], // 失败的文件
      successtotals: 0, //成功的条数
      dangertotals: 0, //失败的条数
      isfail: 2, // 1 展示失败 0展示成功 2展示文件列表页
      successsrc: require("@/CommonDP/assets/addpersonInfo/导入成功.png"),
      dangersrc: require("@/CommonDP/assets/addpersonInfo/导入失败.png"),
      exportLoading: false,
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId,
    }),
  },
  created() {
    this.getPersonList(1);
  },
  methods: {
    changeinput() {
      this.getPersonList(1);
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getPersonList(1);
    },
    // 人员列表接口
    getPersonList(index = 1) {
      this.$nextTick(() => {
        this.$refs.multipleTable.clearSelection();
      });
      const {
          page: { pageSize },
          searchQuery: { keyword, isExternal, isEnabled },
          enterpriseId,
        } = this,
        params = {
          keyword,
          pageSize,
          pageNum: index,
          isEnabled,
          isExternal,
          enterpriseId,
        };
      systemPersonService
        .personListTable(params)
        .then(({ data, totalCount, pageNum }) => {
          const list = data.map((person) => {
            const isEnableds = ["禁用", "启用"];
            const sex = ["", "男", "女"];
            return {
              depName: "",
              depNametitle: "",
              $isEnabled: isEnableds[person.isEnabled],
              $sex: sex[person.sex],
              ...person,
            };
          });
          this.page.pageNum = pageNum;
          this.page.totalCount = totalCount;
          this.tableData = list;
          for (var i = 0; i < this.tableData.length; i++) {
            if (this.tableData[i].deptList.length) {
              for (var l = 0; l < this.tableData[i].deptList.length; l++) {
                this.tableData[i].depName +=
                  this.tableData[i].deptList[l].deptName + ";";
                this.tableData[i].depNametitle +=
                  this.tableData[i].deptList[l].fullDeptName + ";";
              }
              //去掉最后一个符号
              this.tableData[i].depName = this.tableData[i].depName.substring(
                0,
                this.tableData[i].depName.length - 1
              );
              this.tableData[i].depNametitle = this.tableData[
                i
              ].depNametitle.substring(
                0,
                this.tableData[i].depNametitle.length - 1
              );
            }
          }
          var data222 = [];
          for (var s = 0; s < this.pageSelect.length; s++) {
            for (var g = 0; g < this.tableData.length; g++) {
              if (this.pageSelect[s].userId == this.tableData[g].userId) {
                data222.push(this.tableData[g]);
              }
            }
          }
          this.toggleSelection(data222);
          this.userId = undefined;
          this.loading = false;
        });
    },
    // 翻页勾选
    toggleSelection(rows) {
      this.$nextTick(() => {
        if (rows) {
          rows.forEach((row) => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      });
    },
    // 选中的节点
    handleDelete(selection) {
      console.log(selection, "点击");
      this.userId = selection.userId;
    },
    // 删除人员
    deletePerson(row) {
      const a = disablePrompt();
      if (a) {
        const params = { enterpriseId: this.enterpriseId, userIds: [] };
        params.userIds.push(row.userId);
        this.$confirm("此操作将删除本行数据，是否继续？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            systemPersonService
              .personnelmanagedelete(params)
              .then(() => {
                this.getfreshen(); // 刷新列表
                this.$message({
                  showClose: true,
                  type: "success",
                  message: "删除成功",
                });
              })
              .catch(() => {});
          })
          .catch(() => {
            this.getfreshen();
          });
        this.userId = undefined;
      }
    },
    // 批量删除人员
    pldeletePerson() {
      const a = disablePrompt();
      if (a) {
        const params = { enterpriseId: this.enterpriseId, userIds: [] };
        for (var i = 0; i < this.pageSelect.length; i++) {
          params.userIds.push(this.pageSelect[i].userId);
        }
        this.$confirm("此操作将删除数据，是否继续？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            systemPersonService.personnelmanagedelete(params).then(() => {
              this.getfreshen(); // 刷新列表
              this.$message({
                showClose: true,
                type: "success",
                message: "删除成功",
              });
              this.pageSelect = [];
            });
          })
          .catch(() => {
            this.getfreshen();
          });
      }
    },
    getfreshen() {
      this.getPersonList(1);
    },
    getfreshen1() {
      this.userId = undefined;
      this.getPersonList(1);
    },
    async detailInfo(row) {
      const a = disablePrompt();
      if (a) {
        const { data } = await systemPersonService.detailPerson(
          row.enterpriseUserId
        );
        if (data.sex) {
          if (data.sex == "1") {
            data.sex = "男";
          } else {
            data.sex = "女";
          }
        }
        this.$refs.add.setPersonInfo(data, 1);
      }
    },
    // 编辑
    async editPerson(row) {
      const a = disablePrompt();
      if (a) {
        const { data } = await systemPersonService.detailPerson(
          row.enterpriseUserId
        );
        if (data.sex) {
          if (data.sex == "1") {
            data.sex = "男";
          } else {
            data.sex = "女";
          }
        }
        this.$refs.add.setPersonInfo(data, 2);
      }
    },
    rowStyle() {
      return "height:60px";
    },
    headerStyle() {
      return "background-color: #F7F9FF;color:#2E384D;padding:6px 0;height:54px;border-top:1px solid #EFF0F9";
    },
    yaoqing() {
      const a = disablePrompt();
      if (a) {
        this.$router.push("/addpersonInfo");
      }
    },
    qiyong(row) {
      const a = disablePrompt();
      if (a) {
        this.$confirm("确定启用，是否继续？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            systemPersonService.enabled(row.enterpriseUserId, true).then(() => {
              this.getfreshen(); // 刷新列表
              this.$message({
                showClose: true,
                type: "success",
                message: "启用成功",
              });
            });
          })
          .catch(() => {
            this.getfreshen();
          });
      }
    },
    jinyong(row) {
      const a = disablePrompt();
      if (a) {
        this.$confirm("确定禁用，是否继续？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            systemPersonService
              .enabled(row.enterpriseUserId, false)
              .then(() => {
                this.getfreshen(); // 刷新列表
                this.$message({
                  showClose: true,
                  type: "success",
                  message: "禁用成功",
                });
              });
          })
          .catch(() => {
            this.getfreshen();
          });
      }
    },
    selectall(rows) {
      if (rows.length) {
        var result = [];
        if (this.pageSelect.length) {
          for (var i = 0; i < this.tableData.length; i++) {
            var obj = this.tableData[i];
            var num = obj.userId;
            var isExist = false;
            for (var j = 0; j < this.pageSelect.length; j++) {
              var aj = this.pageSelect[j];
              var n = aj.userId;
              if (n == num) {
                isExist = true;
                break;
              }
            }
            if (!isExist) {
              result.push(obj);
            }
          }
          for (var u = 0; u < result.length; u++) {
            this.pageSelect.push(result[u]);
          }
        } else {
          for (var i = 0; i < this.tableData.length; i++) {
            this.pageSelect.push(this.tableData[i]);
          }
        }
      } else {
        for (var t = 0; t < this.tableData.length; t++) {
          this.removeByValue(
            this.pageSelect,
            "userId",
            this.tableData[t].userId
          );
        }
      }
    },
    selectchange(rows, row) {
      let selected = rows.length && rows.indexOf(row) !== -1;
      if (!selected) {
        this.removeByValue(this.pageSelect, "userId", row.userId);
      } else {
        this.pageSelect.push(row);
      }
    },
    // 复选框不勾选时需要调用的函数
    removeByValue(arr, attr, value) {
      //数组，属性，属性值
      var index = 0;
      for (var i in arr) {
        if (arr[i][attr] == value) {
          index = i;
          break;
        }
      }
      arr.splice(index, 1);
    },
    daoru() {
      const a = disablePrompt();
      if (a) {
        this.professionDialogVisible4 = true;
        this.disabledone2 = false;
        this.fileList2 = [];
        this.dangerlist = [];
        this.isfail = 2;
      }
    },

    //导出excel
    exportExcel() {
      const { enterpriseId } = this;
      const { isEnabled, keyword } = this.searchQuery;
      const url = interiorService.exportExcelUrl(
        enterpriseId,
        isEnabled,
        keyword
      );
      this.exportLoading = true;
      axios({
        method: "get",
        url,
        headers: {
          Authorization: getToken() ? "Bearer " + getToken() : "",
        },
        responseType: "blob",
      })
        .then((res) => {
          const content = res;
          const blob = new Blob([content.data]);
          const fileName = "内部人员.xlsx";
          if ("download" in document.createElement("a")) {
            const elink = document.createElement("a");
            elink.download = fileName;
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href);
            document.body.removeChild(elink);
          } else {
            navigator.msSaveBlob(blob, fileName);
          }
          this.exportLoading = false;
        })
        .catch((error) => {
          this.exportLoading = false;
          this.$message.warning(error.message);
        });
    },

    invite() {
      this.$router.push({ path: "/addpersonInfo", query: { addType: "0" } });
    },

    // 关闭驳回弹框
    handlePofessionClose4() {
      this.professionDialogVisible4 = false;
    },
    //上传1
    dataprogress1(file) {
      console.log(file, "1");
      var tt = file.name;
      var ttt = tt.split(".");
      var ttl = ttt.length;
      const isXLSX = ttt[ttl - 1] === "xlsx";
      const isXLS = ttt[ttl - 1] === "xls";
      const isPG = isXLSX || isXLS;
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isPG) {
        this.$message({
          showClose: true,
          message: "上传文件只能是 .xls .xlsx 格式!",
          type: "warning",
        });
      } else if (!isLt2M) {
        this.$message({
          showClose: true,
          message: "上传文件大小不能超过 5M!",
          type: "warning",
        });
      }
      return isPG && isLt2M;
    },
    //上传2
    async httpRequest({ file }) {
      this.fileList2.push(file);
    },
    newuplode() {
      this.disabledone2 = false;
      this.fileList2 = [];
      this.dangerlist = [];
      this.isfail = 2;
    },
    suredaoru() {
      this.disabledone2 = true;
      const data = new FormData();
      data.append("file", this.fileList2[0]);
      data.append("enterpriseId", this.enterpriseId);
      systemPersonService
        .enterpriseimport(data)
        .then((res1) => {
          console.log(data);

          if (res1.result == "0") {
            this.disabledone2 = false;
            if (res1.data.failList.length) {
              // 导入失败
              this.successtotals = res1.data.total - res1.data.failList.length; //成功条数
              this.dangertotals = res1.data.failList.length; //失败条数
              this.dangerlist = res1.data.failList;
              this.isfail = 1;
            } else {
              // 导入成功
              this.dangerlist = [];
              this.successtotals = res1.data.total;
              this.isfail = 0;
            }
            this.getPersonList();
          }
        })
        .catch(() => {
          this.disabledone2 = false;
        });
    },
    async getList(failList) {
      systemPersonService
        .drawingDrawingQuesExport(failList)
        .then((response) => {
          const fileName = "导入失败列表.xlsx";
          if ("msSaveOrOpenBlob" in navigator) {
            // 兼容ie
            // var blob = response
            window.navigator.msSaveOrOpenBlob(response, fileName);
            return;
          } else {
            const link = document.createElement("a");
            const blob = response;
            link.style.display = "none";
            link.href = URL.createObjectURL(blob);
            link.setAttribute("download", decodeURI(fileName));
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        });
    },
    down() {
      let downzipurl = downloadTemplate();
      const iframe = document.createElement("iframe");
      iframe.style.display = "none";
      iframe.style.height = 0;
      iframe.src = downzipurl;
      document.body.appendChild(iframe);
      setTimeout(() => {
        iframe.remove();
      }, 5 * 60 * 1000);
    },
    gomorepersonInfo() {
      const a = disablePrompt();
      if (a) {
        this.$router.push({ path: "/morepersonInfo", query: { type: "0" } });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.all {
  height: 100%;
  background: #fff;
  position: relative;
  min-width: 980px;
  /deep/ .profession-dialog {
    border-radius: 5px;
    .el-dialog__body {
      padding: 20px;
      border-top: 1px solid #2e5bff1a;
      border-bottom: 1px solid #2e5bff1a;
      .el-radio {
        height: 25px;
      }
      .el-form-item {
        margin-bottom: 10px;
      }
    }
    .el-table__empty-text {
      line-height: 30px;
    }
    .el-textarea__inner {
      height: 200px;
    }
  }
  /deep/ .daoru-dialog {
    border-radius: 5px;
    .el-dialog__body {
      padding: 20px;
      border-top: 1px solid #2e5bff1a;
      border-bottom: 1px solid #2e5bff1a;
      .el-radio {
        height: 25px;
      }
      .el-form-item {
        margin-bottom: 10px;
      }
      .el-upload-dragger {
        margin: 0 auto;
      }
    }
    .el-table__empty-text {
      line-height: 30px;
    }
    .el-textarea__inner {
      height: 200px;
    }
  }
  .isEnabledsty {
    /deep/ .el-input__suffix {
      top: -3px !important;
    }
  }
}
.header-top {
  padding-top: 15px;
  .icon_1 {
    color: #1089c8;
    font-size: 23px;
  }
  .header_h {
    padding-left: 20px;
    font-size: 16px;
    line-height: 30px;
    font-weight: 600;
    font-stretch: normal;
    letter-spacing: 1px;
    color: #333333;
  }
  .header_b {
    margin-top: 10px;
  }
}

.midd {
  position: absolute;
  bottom: 90px;
  left: 0;
  right: 0;
  top: 120px;
  padding-left: 20px;
}
.page-1 {
  position: absolute;
  right: 20px;
  bottom: 20px;
}
h4 {
  line-height: 20px;
  font-size: 14px;
  color: #fff;
  padding-left: 10px;
  margin-top: 5px;
  background-color: rgb(170, 165, 165);
}
.btn {
  cursor: pointer;
  color: #5584ff;
  margin-right: 6px;
}
</style>
